import {Component, EventEmitter, Input, NgZone, Output} from '@angular/core';
import {XYType} from '../xytype';
import {CompareManager} from '../tools';

@Component({
    selector: 'raain-compare-stack',
    templateUrl: './raain-compare-stack.component.html',
    styleUrls: ['./raain-compare-stack.component.scss'],
})
export class RaainCompareStackComponent {
    @Input()
    public compareManager: CompareManager;

    @Input()
    public currentHeight: number;

    @Output()
    public selectedPoint = new EventEmitter<{point: XYType; compareIndex: number}>();

    @Input()
    public cumulative: boolean;

    constructor(private ngZone: NgZone) {}

    protected onClick(e: {point: XYType; compareIndex: number}): void {
        this.selectedPoint.emit({point: e.point, compareIndex: e.compareIndex});
    }

    exportCumulativeToCsv(): void {
        const points = this.compareManager.globalComparePoints;
        if (!points?.length) {
            return;
        }

        const dates = this.compareManager.compareDates;
        const dateRange =
            dates?.length > 0
                ? `${this.formatDate(dates[0])} - ${this.formatDate(dates[dates.length - 1])}`
                : '';

        const csvRows = ['dateRange,gaugeName,gaugeValue,pixelValue'];
        for (const point of points) {
            csvRows.push(`${dateRange},${point.name},${point.x},${point.y}`);
        }

        const csvContent = csvRows.join('\n');
        this.downloadCsv(
            csvContent,
            `compare-cumulative-${this.formatDateForFilename(new Date())}.csv`
        );
    }

    exportGranularToCsv(): void {
        const allPoints = this.compareManager.getAllGranularComparePoints();
        if (!allPoints?.length) {
            return;
        }

        const csvRows = ['date,gaugeName,gaugeValue,pixelValue'];
        for (const point of allPoints) {
            const dateStr = this.formatDate(point.date);
            csvRows.push(`${dateStr},${point.gaugeName},${point.gaugeValue},${point.pixelValue}`);
        }

        const csvContent = csvRows.join('\n');
        this.downloadCsv(
            csvContent,
            `compare-granular-${this.formatDateForFilename(new Date())}.csv`
        );
    }

    private downloadCsv(content: string, filename: string): void {
        const blob = new Blob([content], {type: 'text/csv;charset=utf-8;'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.click();
        URL.revokeObjectURL(url);
    }

    private formatDate(date: Date): string {
        return date ? date.toISOString().slice(0, 16).replace('T', ' ') : '';
    }

    private formatDateForFilename(date: Date): string {
        return date.toISOString().slice(0, 10);
    }
}
